"use client";

import React from "react";

// Imported directly, bypassing the "@/components/common" barrel - that
// barrel also re-exports LoginModal/FormikInput/FormikRadio, which pull in
// `formik` + `crypto-js` (see layout.tsx's own comment on this). This
// component is used across most static marketing pages, so importing the
// barrel here re-leaked that weight onto pages with no forms/login at all.
import CommonImage from "../commonImage/commonImage.component";
import InfiniteScroll from "../infiniteScroll/infiniteScroll.component";
import { cn } from "@/lib/utils";

interface MerchantsSectionProps {
  merchants?: IMerchant[];
}

export default function MerchantsSection({
  merchants = [],
}: MerchantsSectionProps): React.ReactNode {
  return (
    <section className=" ">
      <div className="max-w-[85rem] mx-auto pt-20 pb-30 px-6 md:px-20 w-full flex flex-col items-center justify-center ">
        <h2 className="text-center mb-10 text-[20px] leading-[140%]">
          Built for Every Business -{" "}
          <strong className="font-black">Trusted by the Best</strong>{" "}
        </h2>
        <InfiniteScroll speed={50} gap={"sm"} label="Trusted merchants">
          <div className="flex gap-24">
            {merchants.map((logo) => (
              <div
                key={logo.id}
                className="basis-1/3 sm:basis-1/4 md:basis-1/6 lg:basis-1/8 flex justify-center items-center"
              >
                <CommonImage
                  src={logo.src}
                  alt={logo.alt}
                  className={cn("w-20 ")}
                  width={90}
                  height={90}
                />
              </div>
            ))}
          </div>
        </InfiniteScroll>
      </div>
    </section>
  );
}
